import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/system';
import {
    themeObject,
    DictionaryAttribute,
    DictionaryIndex,
    themeObject as theme,
    IDataType,
} from '../../../../lib';
import { dataTypes } from '../../dictionary-manager/dictionary-manager-helper';
import { REFERENCE_TYPE } from '../../dicitionary.helper';
import { Popover, PopoverProps } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import { TreeItemProps } from '@mui/x-tree-view/TreeItem';
import StringSvg from 'assets/attributes/string.svg';
import IntegerSvg from 'assets/attributes/integer.svg';
import LongSvg from 'assets/attributes/long.svg';
import BooleanSvg from 'assets/attributes/boolean.svg';
import DecimalSvg from 'assets/attributes/decimal.svg';
import DateSvg from 'assets/attributes/date.svg';
import DateTimeSvg from 'assets/attributes/datetime.svg';
import FingerprintSvg from 'assets/attributes/fingerprint.svg';
import EnumSvg from 'assets/attributes/enum.svg';
import BlobSvg from 'assets/attributes/blob.svg';
import ObjectSvg from 'assets/attributes/object.svg';
import StringArraySvg from 'assets/attributes/string-array.svg';
import IntegerArraySvg from 'assets/attributes/integer-array.svg';
import LongArraySvg from 'assets/attributes/long-array.svg';
import BooleanArraySvg from 'assets/attributes/boolean-array.svg';
import DecimalArraySvg from 'assets/attributes/decimal-array.svg';
import DateArraySvg from 'assets/attributes/date-array.svg';
import DateTimeArraySvg from 'assets/attributes/datetime-array.svg';
import EnumArraySvg from 'assets/attributes/enum-array.svg';
import BlobArraySvg from 'assets/attributes/blob-array.svg';
import ClobSvg from 'assets/attributes/clob.svg';
import StringReferenceSvg from 'assets/attributes/string-reference.svg';
import ReferenceStringArraySvg from 'assets/attributes/string-reference-array.svg';
import IntegerReferenceSvg from 'assets/attributes/integer-reference.svg';
import IntegerReferenceArraySvg from 'assets/attributes/integer-reference-array.svg';
import LongReferenceSvg from 'assets/attributes/long-reference.svg';
import LongReferenceArraySvg from 'assets/attributes/long-reference-array.svg';
import VectorSvg from 'assets/attributes/vector.svg';

export const AttributeIcons: Record<string, any> = {
    STRING: StringSvg,
    INTEGER: IntegerSvg,
    LONG: LongSvg,
    BOOLEAN: BooleanSvg,
    DECIMAL: DecimalSvg,
    DATE: DateSvg,
    DATETIME: DateTimeSvg,
    FINGERPRINT: FingerprintSvg,
    ENUM: EnumSvg,
    BLOB: BlobSvg,
    OBJECT: ObjectSvg,
    CLOB: ClobSvg,
    STRING_ARRAY: StringArraySvg,
    INTEGER_ARRAY: IntegerArraySvg,
    LONG_ARRAY: LongArraySvg,
    BOOLEAN_ARRAY: BooleanArraySvg,
    DECIMAL_ARRAY: DecimalArraySvg,
    DATE_ARRAY: DateArraySvg,
    DATETIME_ARRAY: DateTimeArraySvg,
    ENUM_ARRAY: EnumArraySvg,
    BLOB_ARRAY: BlobArraySvg,
    OBJECT_ARRAY: ObjectSvg,
    STRING_REFERENCE: StringReferenceSvg,
    STRING_REFERENCE_ARRAY: ReferenceStringArraySvg,
    INTEGER_REFERENCE: IntegerReferenceSvg,
    INTEGER_REFERENCE_ARRAY: IntegerReferenceArraySvg,
    LONG_REFERENCE: LongReferenceSvg,
    LONG_REFERENCE_ARRAY: LongReferenceArraySvg,
    VECTOR: VectorSvg,
};

export const ATTRIBUTE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const attributeStyles = {
    treeView: {
        height: '500px',
        flexGrow: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        ml: 6.0475,
        ul: {
            paddingLeft: '35px',
        },
        'ul li': {
            listStyleType: 'none',
            paddingLeft: 0,
            position: 'relative',
        },
        'ul li:before': {
            content: '""',
            position: 'absolute',
            top: '-5px',
            left: 0,
            borderRight: `1px solid ${themeObject.palette.grayScale[300]}`,
            borderBottom: `1px solid ${themeObject.palette.grayScale[300]}`,
            borderRadius: 0,
            height: '100%',
        },
        'ul li:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: '27px',
            left: 0,
            borderTop: `1px solid ${themeObject.palette.grayScale[300]}`,
            height: '100%',
            width: '37px',
        },
        'ul li:last-of-type:before': {
            height: '32px',
            borderRight: `1px solid ${themeObject.palette.grayScale[300]}`,
        },
        treeViewCard: {
            mt: 0,
            marginRight: '50px',
            width: '100%',
        },
    },
    treeViewContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '50px',
        width: '100%',
        height: '100%',
    },
    fabButtonContainerStyles: {
        mt: '27px',
        ml: '26px',
        mb: '32px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    errorStateContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end',
        ml: 3.125,
    },
    errorStateIcon: {
        color: themeObject.palette.tertiary.red[500],
        fontSize: '16px',
    },
    errorStateText: {
        ml: 0.875,
        ...themeObject.typography.captions.default,
        color: themeObject.palette.error[600],
    },
    fabButtonStyles: {
        borderRadius: '64px',
        width: '136px',
        height: '34px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
            ml: '3px',
        },
    },
    attributeHighlights: {
        highlightCard: {
            mt: 0,
            marginRight: '50px',
            width: '100%',
        },
        highlightCardContent: {
            padding: 0,
            '&:last-child': {
                pb: 0,
            },
        },
        highlightText: {
            ml: 1,
            fontWeight: '500',
            fontFamily: 'Red Hat Mono',
            fontSize: '16px',
            lineHeight: '21.17px',
            letter: '2px',
            color: themeObject.palette.grayScale[700],
        },
        highlightBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '1px',
        },
        imageContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        image: {
            marginRight: '4px',
        },
        checkboxControl: {
            mr: 0,
        },
        imgAndTextContainer: {
            display: 'flex',
            alignItems: 'center',
            ml: 7.5,
            mr: 3.5,
            mt: 2,
            width: 'calc(100% - 100px)',
        },
        highlightIcon: {
            height: '24px',
            width: '24px',
            color: themeObject.palette.grayScale[500],
        },
        dividerContainer: {
            width: 'calc(100% - 85px)',
            my: 1.5,
            ml: 4.5,
            mr: 6.5,
            color: themeObject.palette.grayScale[200],
        },
        highlightContainer: {
            height: '600px',
            overflow: 'auto',
            ml: 2.8125,
            mr: 1.5,
        },
    },
    boxStyle: { display: 'flex' },
    boxNestedStyle: {
        width: '100%',
        marginRight: 2,
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        backgroundColor: themeObject.palette.background.default,
        borderRadius: '5px',
    },
    boxNestedSecStyle: {
        width: '22%',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        backgroundColor: themeObject.palette.background.default,
        borderRadius: '5px',
    },
    commonMarginRightOne: { mr: 1, p: '8px 11px' },
    commonMarginRightTwo: { mr: 2, p: '8px 11px' },
    requiredLabel: {
        fontFamily: 'Red Hat Text',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        color: themeObject.palette.grayScale[600],
    },
    treeItemMainContainer: {
        display: 'flex',
        padding: '5px',
    },
    treeItemInfoContainer: {
        marginRight: '5px',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    treeItemInnerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    treeItem: {
        borderRadius: '5px',
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        maxWidth: '275px',
        backgroundColor: 'transparent',
    },
    highlightedItemTree: {
        backgroundColor: alpha(themeObject.palette.primary[500], 0.12),
    },
    errorStateItemTree: {
        backgroundColor: alpha(themeObject.palette.tertiary.red[300], 0.12),
        border: `1px solid ${themeObject.palette.tertiary.red[500]}`,
    },
    dataTypeImage: {
        width: '25px',
        height: '25px',
        ml: '4px',
        mt: '3.5px',
    },
    attributeName: {
        ml: '4px',
        mt: '3px',
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body2,
        ...themeObject.typography.body.medium,
        color: themeObject.palette.grayScale[800],
        lineHeight: '18.52px',
        textWrap: 'nowrap',
    },
    expandIcon: {
        color: themeObject.palette.primary[700],
        backgroundColor: 'transparent',
        visibility: 'visible',
        '&:hover': {
            backgroundColor: alpha(themeObject.palette.primary[500], 0.3),
            color: themeObject.palette.primary[700],
        },
        '&:active': {
            backgroundColor: alpha(themeObject.palette.primary[500], 0.3),
            color: themeObject.palette.primary[700],
        },
        '& .MuiSvgIcon-root': {
            height: '18px',
            width: '18px',
        },
    },
    objectOnlyExpandedIcon: {
        mr: 0.5,
    },
    hiddenExpandedIcon: {
        visibility: 'hidden',
    },
    visibleExpandedIcon: {
        visibility: 'visible',
    },
    objectAddIcon: {
        height: '19px',
        width: '19px',
        color: themeObject.palette.tertiary.purple[400],
    },
    infoContainer: {
        ml: '26px',
        mr: '10px',
        mt: '5px',
    },
    description: {
        mb: '6px',
        wordBreak: 'break-all',
        ...themeObject.typography.captions.default,
        color: themeObject.palette.grayScale[800],
    },
    dataType: {
        mb: '11px',
        ...themeObject.typography.captions.default,
        color: themeObject.palette.grayScale[800],
    },
};

export const attributeDrawerStyles = {
    drawer: {
        width: '360px',
        '& .MuiPaper-root': {
            '& .drawer-content': {
                padding: 0,
                height: '100%',
                overflowY: 'auto',
            },
            '& .drawer-footer': {
                mt: 0,
                width: '300px',
            },
        },
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        ...themeObject.typography.h3,
        color: `${themeObject.palette.primary[700]}`,
        fontVariantNumeric: 'lining-nums',
    },
    bodyContainer: {
        width: '300px',
        display: 'flex',
        flexDirection: 'column',
    },
    overFlowBodyContainer: {
        height: '100%',
        overflow: 'auto',
        overflowAnchor: 'auto !important',
    },
    itemContainer: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
        mb: 2,
    },
    dictionaryReferenceContainer: {
        width: '300px',
    },
    dictionaryReferenceDropdown: {
        width: '298px',
        maxHeight: '245px',
    },
    requiredItemContainer: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    textFields: {
        width: '100%',
        '& .MuiInputBase-input': {
            height: '39px',
        },
    },
    attributeItemContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    attributeItemImg: {
        height: '20px',
        width: '20px',
    },
    attributeItemText: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
        my: 0.75,
        ml: 1,
    },
    dropDownMenuHeight: {
        maxHeight: '420px',
    },
    footerContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
    },
    customAttributesMainListContainerStyles: {
        mt: '12px',
        overflowY: 'auto',
        height: 'calc(100vh - 730px)',
    },
    customAttributesSelectedListContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        '& [role=button]': {
            '& .MuiGrid-root': {
                '& .MuiGrid-root': {
                    p: 0,
                    '& .MuiFormControlLabel-root': {
                        width: '100%',
                    },
                    '& .MuiTypography-root': {
                        width: '210px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                },
            },
        },
    },
    attributeInUseErrorContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        ml: 1.5,
        mr: 4,
        mb: 2,
    },
    errorIcon: {
        color: themeObject.palette.tertiary.red[300],
        fontSize: '11px',
        mb: '18px',
        mr: '3px',
    },
    attributeInUseError: {
        ...themeObject.typography.captions.default,
        color: themeObject.palette.error[600],
    },
    drawerFooterWithErrorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
};

export const dataTypeWarningStyles = {
    root: {
        width: '225px',
        boxShadow: `0px 1px 18px 0px ${alpha(
            theme.palette.grayScale[700],
            0.12
        )},0px 6px 10px 0px${alpha(
            theme.palette.grayScale[700],
            0.14
        )},0px 3px 5px -1px ${alpha(theme.palette.grayScale[700], 0.2)}`,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mx: 3.5,
        mb: 1.5,
    },
    warningMessage: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        color: themeObject.palette.grayScale[800],
        verticalAlign: 'center',
        mx: 1.5,
        mt: 1.5,
    },
    confirmButton: {
        width: '169px',
        mt: 1,
        mb: 1.5,
    },
    cancelButton: {
        width: '94px',
        mx: 4.6875,
    },
};

export const CustomExpandIcon = styled(ExpandMoreIcon)(() => ({
    color: themeObject.palette.primary[400],
    height: '24px',
    width: '24px',
}));

export const CustomCollapseIcon = styled(ExpandLessIcon)(() => ({
    color: themeObject.palette.primary[400],
    height: '24px',
    width: '24px',
}));

/*
    Solution taken from: https://stackoverflow.com/a/76948170

    Convert this helper into a component if it needs to change. For example, we could make the anchorOrigin, tranformOrigin, and arrow
    placement properties we could override if needed. Since this is being used as an example for now, let's keep it as a helper function for the
    edit attribute drawer only. It needs to be reused outside the scope it's suggested to move it to a global location or create a real component.
 */
export const PopoverWithArrow = (
    popoverProps: Omit<PopoverProps, 'anchorOrigin' | 'transformOrigin'>
): React.JSX.Element => (
    <Popover
        anchorOrigin={{
            vertical: -15,
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 10,
        }}
        slotProps={{
            paper: {
                sx: {
                    overflow: 'visible',
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        bottom: -10,
                        right: 20,
                        width: 15,
                        height: 15,
                        backgroundColor: themeObject.palette.background.paper,
                        transform: 'translateY(-50%) rotate(45deg)',
                    },
                },
            },
        }}
        {...popoverProps}
    />
);

export interface AttributeDataType {
    datatype: string;
    id: string;
    name: string;
    precision: number;
    defaultValue: string;
    required: boolean;
}

export interface AttributeTreeViewProps {
    selectedNodeId?: string;
    onNodeSelected: Function;
    handleAddAttribute: any;
    attributes: any;
    defaultExpandedIds: string[];
    uniqueAttributeTypes: Set<string>;
    isErrorState: boolean;
}

export interface AttributeTreeItemProps extends TreeItemProps {
    attribute: DictionaryAttribute;
    onNodeSelected: Function;
    setExpandedNodes: Function;
    nodeId: string;
    shouldHighlight: Function;
    setExpandedNodeInfoId: (id: string) => void;
    expandedNodeInfoId: string;
}

export interface AttributeRecord {
    key: string;
    value: string;
}

export const possiblyPopulateNodeAttributes = (
    attribute: DictionaryAttribute
): DictionaryAttribute => {
    let attributeCopy: DictionaryAttribute = { ...attribute };
    if (attribute?.nodeAttributes) {
        attributeCopy.attributes = attribute.nodeAttributes;
    }

    return attributeCopy;
};

export const isAttributeObjectGroup = (
    attribute: DictionaryAttribute
): boolean => {
    return (
        attribute.datatype === 'OBJECT' || attribute.datatype === 'OBJECT_ARRAY'
    );
};

export const isAttributeErrorState = (
    attribute: DictionaryAttribute
): boolean => {
    return (
        isAttributeObjectGroup(attribute) && !attribute.nodeAttributes?.length
    );
};

const getDictionaryTypes = (attributeList: DictionaryAttribute[]): string[] => {
    let dictionaryTypes: string[] = [];
    for (const item of attributeList) {
        dictionaryTypes = [...dictionaryTypes, item.datatype ?? ''];
        if (item.nodeAttributes?.length) {
            dictionaryTypes = [
                ...dictionaryTypes,
                ...getDictionaryTypes(item.nodeAttributes),
            ];
        }
    }

    return dictionaryTypes;
};

export const getUniqueDictionaryTypes = (
    attributeList: DictionaryAttribute[]
): Set<string> => {
    const attributeTypes: string[] = getDictionaryTypes(attributeList);
    return new Set(attributeTypes);
};

/**
 * Recursively check whether the attribute list is in an error state. An error state is determined
 * if an attribute is of Object or Object[] datatype, and it doesn't have any children. This function recursively
 * check the current state for each attribute and its children.
 * @param attributeList
 */
export const findErrorStateInNestedTree = (
    attributeList: DictionaryAttribute[] = []
): boolean => {
    if (!attributeList.length) return false;

    return attributeList.some(
        (item) =>
            isAttributeErrorState(item) ||
            findErrorStateInNestedTree(item?.nodeAttributes)
    );
};

export const getSortedAttributeTypes = (): IDataType[] => {
    return dataTypes.sort((a: any, b: any) => {
        return a.value.toLowerCase().localeCompare(b.value.toLowerCase());
    });
};

export const getNormalizedDisplayAttributeKey = (value: string): string => {
    if (!value.toLowerCase().includes(REFERENCE_TYPE)) {
        return value;
    }

    return value.split(' ').join(' ');
};

export const getModifiedAttributeKey = (key: string): string => {
    return key
        .replace('_ARRAY', '[]')
        .toLowerCase()
        .replace(/^(.)(.*)$/, (currentVal) => {
            // default value to indicate something went wrong.
            if (!currentVal) return 'N/A';

            return currentVal
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        });
};

export const getModifiedAttributeIconRecords = (
    attributeIconRecord: Record<string, any>,
    uniqueTypes?: Set<string>
): Record<string, any> => {
    const attributeIconEntries: [string, any][] = uniqueTypes
        ? Object.entries(attributeIconRecord).filter(([key]) =>
              uniqueTypes.has(key.toUpperCase())
          )
        : Object.entries(attributeIconRecord);

    return Object.fromEntries(
        attributeIconEntries
            .map(([key, value]) => [getModifiedAttributeKey(key), value])
            .sort(([keyA], [keyB]) => {
                return keyA.toLowerCase().localeCompare(keyB.toLowerCase());
            })
    );
};

export const getUTCFormattedDateString = (date: Dayjs): string => {
    return dayjs(date.toDate()).utc().format(ATTRIBUTE_TIME_FORMAT);
};

const customAttributeSort = (
    attributeList: DictionaryAttribute[]
): DictionaryAttribute[] => {
    return attributeList.sort(
        (a: DictionaryAttribute, b: DictionaryAttribute) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
};

const sortAttributesAlphabetically = (
    attributeList: DictionaryAttribute[]
): DictionaryAttribute[] => {
    let listCopy = [...attributeList];
    listCopy = customAttributeSort(listCopy).map((item) => {
        if (item.nodeAttributes?.length) {
            item = {
                ...item,
                nodeAttributes: sortAttributesAlphabetically(
                    item.nodeAttributes
                ),
            };
        }
        return item;
    });

    return listCopy;
};

const updateDynamicAttributeName = (
    list: DictionaryAttribute[],
    parent?: string
): DictionaryAttribute[] => {
    let listCopy = [...list];
    for (const item of listCopy) {
        let name = item.name;
        if (parent) {
            name = `${parent}.${item.name}`;
        }
        item.dynamicName = name;

        if (item.nodeAttributes?.length) {
            updateDynamicAttributeName(item.nodeAttributes, name);
        }
    }

    return listCopy;
};

const getTruncateText = (displayName: string): string => {
    return displayName.length > 25
        ? `${displayName.slice(0, 25)}...`
        : displayName;
};

const updatePrimaryItemName = (
    attributeList: DictionaryAttribute[],
    primaryKeyList: string[]
): DictionaryAttribute[] => {
    let listCopy = [...attributeList];
    for (const item of listCopy) {
        item.treeViewDisplayName =
            item.dynamicName && primaryKeyList.includes(item.dynamicName)
                ? `${getTruncateText(item.name)} *`
                : getTruncateText(item.name);

        if (item.nodeAttributes?.length) {
            updatePrimaryItemName(item.nodeAttributes, primaryKeyList);
        }
    }

    return listCopy;
};

export const getSortedAttributes = (
    attributeList: DictionaryAttribute[] = [],
    indexList: DictionaryIndex[] = []
): DictionaryAttribute[] => {
    let alphabeticalAttributes = sortAttributesAlphabetically(attributeList);
    alphabeticalAttributes = updateDynamicAttributeName(alphabeticalAttributes);
    let primaryKeyAttributeKeys: string[] | string =
        indexList.find((index: DictionaryIndex) => index.type === 'PRIMARY')
            ?.attributes ?? [];

    // For some reason, if the user only sets one index it comes as a string rather than a single string in array.
    if (
        primaryKeyAttributeKeys &&
        typeof primaryKeyAttributeKeys === 'string'
    ) {
        primaryKeyAttributeKeys = [primaryKeyAttributeKeys];
    }
    alphabeticalAttributes = updatePrimaryItemName(
        alphabeticalAttributes,
        primaryKeyAttributeKeys
    );

    let primaryKeyAttributes: DictionaryAttribute[] = [];
    let nonPrimaryKeyAttributes: DictionaryAttribute[] = [];

    // We want to mark any primary key attributes with an asterisk for visual representation.
    for (const attributeKey of primaryKeyAttributeKeys) {
        for (const item of Object.values(alphabeticalAttributes)) {
            if (item.dynamicName === attributeKey) {
                primaryKeyAttributes = [...primaryKeyAttributes, item];
            }
        }
    }

    // display all the non-primary key attributes.
    for (const item of Object.values(alphabeticalAttributes)) {
        const isPrimaryDictionaryIndex = primaryKeyAttributeKeys.find(
            (attributeKey: string) => attributeKey === item.name
        );

        // only add the attributes that are not part of the primary key.
        if (!isPrimaryDictionaryIndex) {
            nonPrimaryKeyAttributes = [...nonPrimaryKeyAttributes, item];
        }
    }

    return [...primaryKeyAttributes, ...nonPrimaryKeyAttributes];
};

export const getDefaultExpandedNodeIds = (
    attributeList: DictionaryAttribute[],
    list: string[]
): string[] => {
    for (const attribute of attributeList) {
        // only include nodes that are Objects or Object arrays and whose id is present.
        if (attribute?.id && isAttributeObjectGroup(attribute)) {
            list = [...list, attribute.id ?? ''];

            // recursively call this function for each child node to get their nested ids so the child nodes are also expanded.
            if (attribute.nodeAttributes?.length) {
                list = [
                    ...list,
                    ...getDefaultExpandedNodeIds(
                        attribute.nodeAttributes,
                        list
                    ),
                ];
            }
        }
    }

    return list;
};
